module.exports = __webpack_public_path__ + "static/media/V_pictos-07.f808295f.svg";